import React from 'react'
import './Research.css'
import { Link } from 'react-router'

const Research = (props) => {

  document.title = "Research - Out of Last Place Mississippi"

  return (
    <div>
    <section className="pages-hero research-hero">
      <h4>Research Papers</h4>
    </section>

    <section id="research-section" className="content-section research-section">

        <div className="research-content">

          <div className="report">
            <h5>Per Capita Personal Income in Mississippi</h5>

            <p>Per Capita Personal Income in Mississippi</p>

            <Link to={'/pdf/per_capita_income_ms.pdf'} target="_blank" >
              <h5 className="pdf-icon">
                <i className="fa fa-file-pdf-o" aria-hidden="true"></i> Download
              </h5>
            </Link>
          </div>

          <hr />

          <div className="report">
            <h5>Labor and Employment in Mississippi</h5>

            <p>Labor and Employment in Mississippi</p>


            <Link to={'/pdf/labor_employment_ms.pdf'} target='_blank' >
              <h5 className="pdf-icon">
                <i className="fa fa-file-pdf-o" aria-hidden="true"></i> Download
              </h5>
            </Link>

          </div>

          <hr />

          <div className="report">
            <h5>Labor Force Participation in Mississippi and Other Southern States – Summary Report</h5>

            <p>Labor Force Participation in Mississippi and Other Southern States – Summary Report</p>

            <a href="http://research.upjohn.org/cgi/viewcontent.cgi?article=1029&context=up_technicalreports" target="_blank"><h5 className="pdf-icon"><i className="fa fa-file-pdf-o" aria-hidden="true"></i> Download</h5></a>
          </div>

          <hr />

          <div className="report">
            <h5>Labor Force Participation in Mississippi and Other Southern States – Final Report</h5>

            <p>Labor Force Participation in Mississippi and Other Southern States – Final Report</p>

            <a href="http://research.upjohn.org/cgi/viewcontent.cgi?article=1030&context=up_technicalreports" target="_blank"><h5 className="pdf-icon"><i className="fa fa-file-pdf-o" aria-hidden="true"></i> Download</h5></a>
          </div>

        </div>

    </section>
  </div>
  )
}

export default Research;



/** WEBPACK FOOTER **
 ** ./src/components/pages/Research.js
 **/